export default defineNuxtPlugin({
  name: 'utm-tracking',
  enforce: 'pre', // Run this plugin early
  setup() {
    if (typeof window === 'undefined') return;

    const { initializeUtmTracking } = useUtmTracking();
    
    // Initialize UTM tracking on app load
    // Run immediately on client side
    if (process.client) {
      // Initialize immediately
      initializeUtmTracking();
      
      // Also initialize after a short delay to catch any late URL params
      setTimeout(() => {
        initializeUtmTracking();
      }, 100);
      
      // Also capture on route changes (for internal navigation)
      // Note: UTM params are preserved in sessionStorage, so they persist across internal navigation
      const router = useRouter();
      router.afterEach(() => {
        // Only update if new UTM params are present in URL
        // Existing stored values are preserved if URL doesn't have new params
        initializeUtmTracking();
      });
    }
  }
});

